export const getBOLSummary = async (vehicleId, bolId, code) => {
  const hasVehicleId =
    vehicleId !== null && vehicleId !== undefined && vehicleId !== "";

  const params = new URLSearchParams(
    hasVehicleId ? { vehicleId } : { code },
  ).toString();

  const url = hasVehicleId
    ? `${process.env.REACT_APP_API_URL}/api/core-service/bol/summary?${params}`
    : `${process.env.REACT_APP_API_URL}/api/core-service/bol/historical/${bolId}?${params}`;

  const config = {
    method: "GET",
  };

  try {
    const res = await fetch(url, config);

    if (res.status >= 400 && res.status < 600) {
      throw new Error("Bad response from server");
    }

    const data = await res.json();

    return Array.isArray(data) ? data : [data];
  } catch (err) {
    console.error("Error fetching data", err);
    return [];
  }
};

export async function getSignedUrl(fileName) {
  const params = new URLSearchParams({
    fileName,
  });

  const url = `
    ${process.env.REACT_APP_API_URL}/api/media-service/media/signed-uri?${params}
  `;

  const config = {
    method: "GET",
  };

  const result = await fetch(url, config);

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result.data;
}
